//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Comments from '../../components/Comments/Comments.vue'
import RequestsExpansionWorksWithWarnings from '../../pages/engineer/EngineerTasks/RequestsExpansionWorksWithWarnings.vue'

export default {
  name: 'TasksAcceptWindow',
  components: {
    Comments,
    RequestsExpansionWorksWithWarnings
  },
  props: {
    proposal: {
      type: Object,
      required: true
    },
    callback: {
      type: Function,
      required: true
    }
  },
  data: function () {
    return {
      requests: null
    }
  },
  created: function () {
    const proposal = this.proposal
    const requestsInitial = proposal.requests
    const requests = JSON.parse(JSON.stringify(requestsInitial))
    let firstToAcceptRequest = null
    requests.forEach((request, index) => {
      const requestInitial = requestsInitial[index]
      request._initial = requestInitial
      request._expand = true

      if (requestInitial.accepted) { // Уже принятые заявки
        request.acceptedDisabled = true // Уже принятые заявки нельзя отменить

        if (proposal.multiReportExists || // При наличии сводного отчета не даем включать/исключать уже принятые
          !requestInitial.multiReportAllowed // + для заявок, которые запрещено включать в сводный
        ) {
          // request.multiReportItemDisabled = true
          request.multiReportItemNotAllowed = true
        } else {
          // Для принятой заявки, которая ожидает включения в сводный отчёт, проставляем включенность в него
          if (!request.singleRepresentationOnly /*  && !proposal.multiReportExists && requestInitial.multiReportAllowed */) {
            request.multiReportItem = true
          }
        }
      } else { // Еще не принятые заявки
        if (requestInitial.firstToAccept) { // Заявка, которую начали принимать
          firstToAcceptRequest = request
          request.accepted = true
        }
        if (!requestInitial.multiReportAllowed) {
          // request.multiReportItemDisabled = true
          request.multiReportItemNotAllowed = true
        } else {
          // Не принятым заявкам, для которых нет блокирующих условий, сразу проставляем включение в него
          if (!requestInitial.multiReportSingularWorkTypes) {
            request.multiReportItem = true
          }
        }
      }

      Object.defineProperty(request, 'warning', {
        get: function () {
          if (this.multiReportItem) {
            return !!this.multiReportSingularWorkTypes
          } else {
            return !!this.multiReportItemBlocked
          }
        }
      })

      Object.defineProperty(request, 'multiReportItemDisabled', {
        get: function () {
          if (this.multiReportItemNotAllowed || this.multiReportItemBlocked) {
            return true // Если заявку запрещено добавлять в сводный отчёт, либо она заблокирована другой заявкой
          }
          if (this.multiReportSingularWorkTypes && !this.accepted && !this.multiReportItem) {
            return true // Если для заявки есть блокирующие факторы включения в отчёт, то для включения в сводный отчёт, сначала нужно принять её
          }
          return false
        }
      })
    })
    this.updateMultiReportBlockedItems(requests)
    if (firstToAcceptRequest) {
      if (firstToAcceptRequest.multiReportAllowed && !firstToAcceptRequest.multiReportItemBlocked) {
        firstToAcceptRequest.multiReportItem = true
        this.updateMultiReportBlockedItems(requests)
      }
    }
    this.requests = requests
  },
  methods: {
    updateMultiReportBlockedItems: function (requests) {
      if (!requests) {
        requests = this.requests
      }

      const includedSingularWorkTypes = new Map()
      requests.forEach(request => {
        if (request.multiReportItem && request.multiReportSingularWorkTypes) {
          request.multiReportSingularWorkTypes.forEach(workType => {
            includedSingularWorkTypes.set(workType.id, workType)
          })
        }
      })

      requests.forEach(request => {
        if (!request.multiReportItem && request.multiReportSingularWorkTypes) {
          let hasBlockingMultiReportItem = false
          for (const workType of request.multiReportSingularWorkTypes) {
            if (includedSingularWorkTypes.has(workType.id)) {
              hasBlockingMultiReportItem = true
              break
            }
          }
          request.multiReportItemBlocked = hasBlockingMultiReportItem
        }
      })
    },
    onAcceptedChange (processingRequest, accepted) {
      processingRequest.accepted = accepted
      this.updateMultiReportBlockedItems()

      if (accepted) {
        if (processingRequest.multiReportSingularWorkTypes && processingRequest.multiReportAllowed && !processingRequest.multiReportItemBlocked) {
          processingRequest.multiReportItem = true
          this.updateMultiReportBlockedItems()
        }
      }
    },
    onMultiReportItemChange (processingRequest, multiReportItem) {
      processingRequest.multiReportItem = multiReportItem
      this.updateMultiReportBlockedItems()
    },
    onApply () {
      const result = {
        requests: this.requests.filter(request => request.accepted === true).map(request => {
          return {
            bpContextId: request.bpContextId,
            accepted: request.accepted,
            multiReportItem: request.multiReportItem
          }
        })
      }

      // this.$q.loading.show({ spinnerColor: 'blue-11' })
      this.callback(result, true).then(() => {
        this.$emit('cancel')
      }).catch((e) => {
        console.log(e)
      })
      // .finally(() => {
      //   this.$q.loading.hide()
      // })
    },
    onCancel () {
      this.callback(null, false)
      this.$emit('cancel')
    },

    onExpand: function (request) {
      request._expand = !request._expand
    },
    onClickSingularWorkType: function (workType) {
      this.$d_ask({
        callback: () => {},
        header: 'Внимание!',
        warning: `Только одна заявка с работой \n
                  «${workType.name}» \n
                  может быть включена в сводный отчёт`,
        buttons: {
          cancel2: 'Понятно'
        }
      })
    },
    onOpen (request) {
      this.$router.push('/task/' + request.id)
    },
    getMultiReportItemCheckboxStyle (request) {
      return 'flex: 1; max-width: 140px; border-style: solid; border-width: 2px; border-radius: 4px;' +
        (request.warning ? request.multiReportItem ? 'border-color: #f57c00; background-color: white;' : 'border-color: white; background-color: #ffe1c2; ' : 'border-color: white; background-color: white;')
    }
  }
}
